import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import {
  Circle,
  Eraser,
  Hand,
  Highlighter,
  Image,
  Layers,
  MousePointer,
  MoveUpRight,
  PaintBucket,
  Pencil,
  Plus,
  Square,
  Type,
} from "lucide-react"
import { Fill, Fill2 } from "../icons/Fill"
import { ComponentProps } from "react"
import { Nudge } from "../icons/Nudge"
import { Grid } from "../icons/Grid"
import { LineIcon } from "../icons/Line"

function FillGray(props: ComponentProps<typeof Fill2>) {
  return <Fill2 fill="#ccc" {...props} />
}

function SquareGray(props: ComponentProps<typeof Square>) {
  return <Square fill="#ddd" {...props} />
}

function MarkerGray(props: ComponentProps<typeof Highlighter>) {
  return <Highlighter fill="#ccc" strokeWidth="1" {...props} />
}

const toolIcons = {
  add: Plus,
  pencil: Pencil,
  arrow: MoveUpRight,
  text: Type,
  square: Square,
  squareFill: SquareGray,
  marker: Highlighter,
  fill: Fill2,
  bucket: PaintBucket,
  hand: Hand,
  "mouse-pointer": MousePointer,
  nudge: Nudge,
  image: Image,
  eraser: Eraser,
  grid: Grid,
  layers: Layers,
  circle: Circle,
  line: LineIcon,
}

type ToolIcon = keyof typeof toolIcons

type Props = {
  icon: ToolIcon
  onClick?: (e: any) => void
  tooltip: string
  tooltipPlacement?: "auto" | "left" | "top" | "bottom"
  selected?: boolean
  children?: React.ReactNode
  variant?: "toggle"
  onHoverStart?: () => void
  onHoverEnd?: () => void
}

/** Intended to go in a {RoundedToolbar} */
export function ToolButton({
  icon,
  onClick,
  children,
  tooltip = "",
  tooltipPlacement = "auto",
  selected = false,
  variant,
  onHoverStart,
  onHoverEnd,
}: Props) {
  const Icon = toolIcons[icon]
  return (
    <Tooltip title={!selected ? tooltip : ""} placement={tooltipPlacement}>
      <div style={{ position: "relative" }}>
        <IconButton
          onClick={onClick}
          onMouseOver={onHoverStart}
          onMouseOut={onHoverEnd}
          disabled={!Boolean(onClick)}
          sx={{
            "&:hover": {
              outline:
                selected && variant !== "toggle"
                  ? "3px solid rgb(12 108 255)"
                  : undefined,
              background: selected ? "rgba(12,108,255,0.1)" : undefined,
              color: selected ? "black" : undefined,
            },
            outline:
              selected && variant !== "toggle"
                ? "3px solid rgb(12 108 255)"
                : undefined,
            background: selected ? "rgba(12,108,255,0.1)" : undefined,
            color: selected ? "black" : undefined,
          }}
        >
          <Icon size={20} />
        </IconButton>
        {selected && children && (
          <div
            style={{
              position: "absolute",
              padding: "0 6px",
              top: 8,
              right: 32,
              borderRadius: 8,
              // background: "rgba(255,255,255,0.5)",
              // backdropFilter: "blur(4px)",
            }}
          >
            {children}
          </div>
        )}
      </div>
    </Tooltip>
  )
}
